<template>
    <div>
        <div v-if="loading" style="min-height: 350px; display: flex; justify-content: center; align-items: center;">
            <img src="/public/img/loading-bar.gif" />
        </div>

        <div v-else class="container-calendario u-mt-20">

            <div class="cal-header">
                <h3 style="margin: 0;"><i class="el-icon-date"></i> Calendário Escolar</h3>
                <span v-if="periodoNome" style="color:#909399;">Período letivo {{ periodoNome }}</span>
            </div>

            <div class="legend">
                <div class="legend-item" v-for="(t, i) in tipos" :key="i">
                    <span class="legend-color" :style="{ backgroundColor: t.color }"></span>
                    <span class="legend-label">{{ t.label }}</span>
                </div>
            </div>

            <div v-if="!periodoYear" style="color:#909399; padding: 20px; text-align:center;">
                Não foi possível identificar o ano letivo do calendário.
            </div>

            <div v-else class="months-grid">
                <div class="month-card" v-for="m in 12" :key="m">
                    <div class="month-header">{{ monthName(m - 1) }} / {{ periodoYear }}</div>
                    <div class="dow-row">
                        <div class="dow">SEG</div>
                        <div class="dow">TER</div>
                        <div class="dow">QUA</div>
                        <div class="dow">QUI</div>
                        <div class="dow">SEX</div>
                        <div class="dow">SÁB</div>
                        <div class="dow">DOM</div>
                    </div>
                    <div class="days-grid">
                        <div
                            v-for="(cell, idx) in monthCells(m - 1)"
                            :key="idx"
                            class="day-cell"
                            :class="cellClass(cell)"
                            :style="cellStyle(cell)"
                        >
                            <div class="day-number">{{ cell.day || '' }}</div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>
<script>
export default {
    data: () => ({
        loading: true,
        tipos: [],
        marks: {},
        ano: null,
        periodoNome: ''
    }),
    computed: {
        periodoYear () {
            const y = parseInt(this.ano, 10)
            return Number.isFinite(y) ? y : null
        }
    },
    mounted () {
        this.load()
    },
    methods: {
        load () {
            this.loading = true
            // período e instituição são resolvidos no backend pela turma do aluno (via token).
            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/portal/calendario`, {}, this.$store.getters.getHeaderAuth).then(response => {
                this.loading = false
                if (response.data && typeof response.data.erro !== 'undefined') {
                    window.eventBus.$emit('alert', { msg: response.data.erro, type: 'warning' })
                    return
                }
                this.tipos = response.data.tipos || []
                this.marks = response.data.marks || {}
                this.ano = response.data.ano
                this.periodoNome = response.data.periodo_nome || ''
            }).catch(error => { this.loading = false; this.$store.commit('throwException', error) })
        },
        monthName (m) {
            const names = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro']
            return names[m] || ''
        },
        pad2 (n) {
            return String(n).padStart(2, '0')
        },
        toDateStr (year, monthIdx, day) {
            return `${year}-${this.pad2(monthIdx + 1)}-${this.pad2(day)}`
        },
        monthCells (monthIdx) {
            const year = this.periodoYear
            if (!year) return []

            const first = new Date(year, monthIdx, 1)
            const jsDow = first.getDay() // 0=dom
            const start = (jsDow + 6) % 7 // 0=seg
            const daysInMonth = new Date(year, monthIdx + 1, 0).getDate()

            const cells = []
            for (let i = 0; i < start; i++) cells.push({ day: null, date: null })
            for (let d = 1; d <= daysInMonth; d++) cells.push({ day: d, date: this.toDateStr(year, monthIdx, d) })

            while (cells.length % 7 !== 0) cells.push({ day: null, date: null })
            return cells
        },
        cellClass (cell) {
            if (!cell || !cell.date) return 'is-empty'
            return { 'has-mark': !!(this.marks && this.marks[cell.date]) }
        },
        cellStyle (cell) {
            if (!cell || !cell.date) return {}
            const tipo = this.marks ? this.marks[cell.date] : null
            const cfg = (this.tipos || []).find(t => t.key === tipo)
            const style = {}
            if (cfg && cfg.color) style.backgroundColor = cfg.color
            return style
        }
    }
}
</script>
<style scoped>
.container-calendario {
    background: #fff;
    border: 1px solid #ebeef5;
    border-radius: 6px;
    padding: 18px;
}
.cal-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 8px;
    margin-bottom: 12px;
}
.legend {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    margin: 10px 0 15px 0;
}
.legend-item {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 12px;
}
.legend-color {
    width: 14px;
    height: 14px;
    border-radius: 3px;
    border: 1px solid rgba(0,0,0,.2);
}
.legend-label {
    color: #333;
}
.months-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 12px;
}
@media (max-width: 1100px) {
    .months-grid { grid-template-columns: repeat(2, 1fr); }
}
@media (max-width: 700px) {
    .months-grid { grid-template-columns: 1fr; }
}
.month-card {
    border: 1px solid #e0e0e0;
    border-radius: 6px;
    overflow: hidden;
    background: #fff;
}
.month-header {
    padding: 8px 10px;
    background: #f5f5f5;
    font-weight: 700;
    text-transform: uppercase;
    font-size: 12px;
    border-bottom: 1px solid #e0e0e0;
}
.dow-row {
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    background: #fafafa;
    border-bottom: 1px solid #eee;
}
.dow {
    font-size: 10px;
    font-weight: 700;
    text-align: center;
    padding: 6px 0;
    color: #555;
}
.days-grid {
    display: grid;
    grid-template-columns: repeat(7, 1fr);
}
.day-cell {
    height: 34px;
    border-right: 1px solid #eee;
    border-bottom: 1px solid #eee;
    position: relative;
    display: flex;
    align-items: flex-start;
    justify-content: flex-end;
    padding: 4px 6px;
    box-sizing: border-box;
    background: #fff;
}
.day-cell.is-empty {
    background: #fbfbfb;
}
.day-number {
    font-size: 11px;
    font-weight: 700;
    color: rgba(0,0,0,.75);
}
.day-cell.has-mark .day-number {
    color: #fff;
}
</style>
